import { BaseApiService } from './baseApiService';

/**
 * Service for content pages and contact operations
 */
class ContentService extends BaseApiService {
  async getContentPage(slug: string) {
    await this.ensureInitialized();
    const response = await this.api.get(`/content/page/${slug}`);
    return response.data;
  }

  async sendContactMessage(payload: {
    name: string;
    email: string;
    subject?: string;
    message: string;
  }): Promise<{ success: boolean; message: string }> {
    await this.ensureInitialized();
    const response = await this.api.post('/contact', payload);
    return response.data;
  }
}

export const contentService = new ContentService();
export default contentService;
